import '../components/MagregatorTheme.css';
import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ConfigContext = createContext();

const fallbackConfigsByOrg = {
    mag: {
        code: 'mag',
        name: 'МАГ',
        fullName: 'Международная академия гештальта',
        website: 'https://mag-gestalt.ru/',
        offerTermsUrl: 'https://mag-gestalt.ru/mag/oferta/',
        privacyPolicyUrl: 'https://mag-gestalt.ru/mag/privacy-policy/',
        privacyPolicyUrlConsent: 'https://mag-gestalt.ru/mag/consent-personal-data/',
        Marketing: 'https://mag-gestalt.ru/mag/marketing/',
        MaketingConsent: 'https://mag-gestalt.ru/mag/consent-personal-data-advertising/',
        phone: '+7 (985) 216-76-02',
        email: 'question@mag-gestalt.ru',
        telegramBotUsername: 'calendar_mag_bot',
        telegramBotUrl: 'https://t.me/calendar_mag_bot',
        colors: {
            primary: '#4958A3',
            primaryHover: '#3b478c',
            primaryLight: '#007bff',
            primaryLightHover: '#0056b3',
            secondary: '#6c757d',
            secondaryHover: '#545b62',
            link: '#4958A3',
            linkHover: '#3b478c',
            cardBackground: '#e2e3e5',
            textColor: '#1d1d1b',
            buttonTextColor: '#ffffff',
            titleColor: '#435190'
        }
    },
    nasledie: {
        code: 'nasledie',
        name: 'Наследие',
        fullName: 'Образовательный центр Наследие',
        website: 'https://nasledietz.ru/',
        offerTermsUrl: 'https://nasledietz.ru/policy',
        privacyPolicyUrl: 'https://nasledietz.ru/policy',
        privacyPolicyUrlConsent: 'https://nasledietz.ru/policy',
        Marketing: 'https://nasledietz.ru/policy',
        MaketingConsent: 'https://nasledietz.ru/policy',
        phone: '+7 (916) 808-48-55',
        email: 'nasledietz@yandex.ru',
        telegramBotUsername: 'calendar_nasledie_bot',
        telegramBotUrl: 'https://t.me/calendar_nasledie_bot',
        colors: {
            primary: '#657664',
            primaryHover: '#1e4220',
            primaryLight: '#657664',
            primaryLightHover: '#3a6347',
            secondary: '#6c757d',
            secondaryHover: '#545b62',
            link: '#2c5f2d',
            linkHover: '#1e4220',
            cardBackground: '#f1ebe1',
            textColor: '#1d1d1b',
            buttonTextColor: '#ffffff',
            titleColor: '#2c5f2d'
        }
    }
};

const resolveFallbackOrgCode = () => {
    if (typeof window === 'undefined') return 'mag';
    const host = window.location.hostname.toLowerCase();
    if (host.includes('nasledie')) return 'nasledie';
    return 'mag';
};

export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (!context) {
        throw new Error('useConfig должен использоваться внутри ConfigProvider');
    }
    return context;
};

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadConfig();
    }, []);

    const loadConfig = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/config`);
            const configData = response.data;
            setConfig(configData);
            document.documentElement.dataset.organization = configData.code;

            // Применяем CSS переменные для цветов
            if (configData.colors) {
                const root = document.documentElement;
                Object.entries(configData.colors).forEach(([key, value]) => {
                    root.style.setProperty(`--color-${key}`, value);
                });
            }
        } catch (error) {
            console.error('Ошибка загрузки конфигурации:', error);
            // Устанавливаем fallback-конфигурацию по текущему домену организации.
            const fallbackOrgCode = resolveFallbackOrgCode();
            const defaultConfig = fallbackConfigsByOrg[fallbackOrgCode] || fallbackConfigsByOrg.mag;
            setConfig(defaultConfig);
            document.documentElement.dataset.organization = defaultConfig.code;

            // Применяем цвета по умолчанию
            const root = document.documentElement;
            Object.entries(defaultConfig.colors).forEach(([key, value]) => {
                root.style.setProperty(`--color-${key}`, value);
            });
        } finally {
            setLoading(false);
        }
    };

    const value = {
        config,
        loading
    };

    return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

